import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import MaxAvDateStore from './../../store/max-av-date.store'
import UserProfileService from './../../../../shared/services/UserProfile.service'
import { MDBContainer, MDBIcon, MDBBtn, MDBCol, MDBCollapse, MDBRow } from 'mdb-react-ui-kit'
import CustomAlert from '../../../../components/shared/CustomAlert'
import moment from 'moment'
import { UIInput, UIInputToggleSwitch } from './../../../../components/forms/form-fields'

import './MaxAvAgeSetting.component.scss'
export default observer(({ Policy, coverageId, carrierId, policyIdx, Fields }) => {
  const {
    User,
    fetchMaxAvAge,
    minDate,
    ageSetting,
    setAgeSetting,
    saveAgeSetting,
    enableBackdate,
    setEnableBackdate,
    enableEditBeyondYear,
    setEnableEditBeyondYear,
  } = MaxAvDateStore
  const minDateHuman = (minDate && moment(minDate).format('MM/DD/YYYY')) || ''
  const [showForm, setShowForm] = useState(false)
  // const [showForm, setShowForm] = useState(false)
  const userId = UserProfileService.getUserId()

  useEffect(() => {
    fetchMaxAvAge(userId)
  }, [userId])

  if (
    !UserProfileService.isA(['system-admin', 'agency-owner', 'internal-admin'], true) ||
    !UserProfileService.isAssumed()
  )
    return <></>

  return (
    <div id='MaxAvAgeSettingComponent'>
      <CustomAlert color='info'>
        <MDBContainer fluid>
          <h6>Max AV Date Setting</h6>
          <span>{User?.name() ? User.name() : 'The agent'} can not modify AV policies beyond this date.</span>
        </MDBContainer>
        <MDBCollapse open={!showForm}>
          <div className='age-row'>
            <div>
              <strong>{minDateHuman}</strong>
            </div>
            <div>
              <strong>({ageSetting} Months)</strong>
              <MDBBtn type='button' color='default' onClick={() => setShowForm(true)} className='date-edit-btn'>
                <MDBIcon icon='pencil-alt' />
              </MDBBtn>
            </div>
          </div>
        </MDBCollapse>
        <MDBCollapse open={showForm}>
          <form>
            <div className='form-row'>
              <div>How many months back of policies can this agent update?</div>
            </div>
            <div className='age-row'>
              <div>
                <strong>{minDateHuman}</strong>
              </div>
              <div>
                <UIInput
                  name='age_months'
                  type='number'
                  placeholder='Num of Months'
                  onChange={evt => {
                    setAgeSetting(evt.target.value)
                  }}
                  required={true}
                  value={ageSetting}
                  rules={{ required: true, minLength: 1, maxLength: 2 }}
                  showValidity={false}
                  onValidityChange={validity => {
                    // SalesTrackerStore.setValidity(idx, 'av_product', validity.isValid)
                  }}
                  autoComplete='off'
                />
                <MDBBtn
                  type='button'
                  color='default'
                  onClick={() => {
                    setShowForm(false)
                    saveAgeSetting()
                  }}
                  className='date-edit-btn'
                >
                  <MDBIcon fas icon='save' />
                </MDBBtn>
              </div>
            </div>
          </form>
        </MDBCollapse>

        <MDBContainer fluid>
          <h6>Enable Backdating</h6>
          <span>{User?.name() ? User.name() : 'The agent'} can set AV Date in the past.</span>
          <UIInputToggleSwitch
            labelOn={'Enabled'}
            labelOff={'Disabled'}
            value={enableBackdate !== false && enableBackdate !== null}
            onChange={evt => setEnableBackdate(evt)}
          />
        </MDBContainer>
        <MDBContainer fluid className='mt-3'>
          <h6>Allow edit beyond current year</h6>
          <span>
            {User?.name() ? User.name() : 'The agent'} can edit AV policies from previous years (outside the current ISO
            week).
          </span>
          <UIInputToggleSwitch
            labelOn={'Enabled'}
            labelOff={'Disabled'}
            value={!!enableEditBeyondYear}
            onChange={evt => setEnableEditBeyondYear(evt)}
          />
        </MDBContainer>
      </CustomAlert>
    </div>
  )
})
